export const restaurantPageQuery = (
  page: number,
  size: number,
  sort: string[] = []
) => {
  const query = new URLSearchParams({
    page: String(page),
    size: String(size),
  });

  sort.forEach((value) => query.append('sort', value));
  return query.toString();
};

export const appendRestaurantQuery = (
  query: URLSearchParams,
  values: Record<string, string | number | boolean | null | undefined>
) => {
  Object.entries(values).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      query.set(key, String(value));
    }
  });

  return query;
};
